import React from 'react';
import { cn } from "@/lib/utils";
import { COLORS } from "@/lib/colors";
import { motion } from "framer-motion";
import { MetricCategory } from './MetricCategory';

interface MetricsTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  currentMetrics: any;
  handleMetricChange: (label: string, value: number, weight?: string) => Promise<void>;
}

const TABS = [
  { id: 'outcomes', label: 'Outcomes' },
  { id: 'expertOpinion', label: 'Expert Opinion' },
  { id: 'facultyResources', label: 'Faculty Resources' },
  { id: 'financialResources', label: 'Financial Resources' },
  { id: 'studentSelectivity', label: 'Student Selectivity' },
  { id: 'facultyResearch', label: 'Faculty Research' },
];

export function MetricsTabs({ activeTab, setActiveTab, currentMetrics, handleMetricChange }: MetricsTabsProps) {
  return (
    <div className="w-full space-y-6">
      {/* Modern Tab Navigation */}
      <div className="flex flex-wrap justify-center items-center gap-2">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={cn(
              "relative px-4 py-2.5 rounded-lg transition-all duration-200",
              "text-sm font-medium",
              "focus:outline-none focus:ring-2 focus:ring-[#274791]/20",
              activeTab === tab.id
                ? "bg-[#274791] text-white shadow-sm"
                : "bg-[#274791]/5 text-[#274791] hover:bg-[#274791]/10"
            )}
          >
            {tab.label}
            {activeTab === tab.id && (
              <motion.div
                layoutId="activeTab"
                className="absolute inset-0 bg-[#274791] rounded-lg -z-10"
                initial={false}
                transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
              />
            )}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm">
        {/* Render your metrics content here based on activeTab */}
        {activeTab === 'outcomes' && (
          <MetricCategory 
            metrics={currentMetrics.outcomes} 
            onMetricChange={handleMetricChange} 
          />
        )}
        {activeTab === 'expertOpinion' && (
          <MetricCategory 
            metrics={currentMetrics.expertOpinion} 
            onMetricChange={handleMetricChange} 
          />
        )}
        {activeTab === 'facultyResources' && (
          <MetricCategory 
            metrics={currentMetrics.facultyResources} 
            onMetricChange={handleMetricChange} 
          />
        )}
        {activeTab === 'financialResources' && (
          <MetricCategory 
            metrics={currentMetrics.financialResources} 
            onMetricChange={handleMetricChange} 
          />
        )}
        {activeTab === 'studentSelectivity' && (
          <MetricCategory 
            metrics={currentMetrics.studentSelectivity} 
            onMetricChange={handleMetricChange} 
          />
        )}
        {activeTab === 'facultyResearch' && (
          <MetricCategory 
            metrics={currentMetrics.facultyResearch} 
            onMetricChange={handleMetricChange} 
          />
        )}
      </div>
    </div>
  );
}